export {default} from './MainCollectFlow';
